import type { TPartnerCommissionCalculationBase } from '../../store/types';

type TPartnerCommissionValue = {
  currency: string;
  commissionPercent: number | string;
  calculationBase: TPartnerCommissionCalculationBase;
};

export const getPartnerCommissions = (
  currencies: string[],
  currentCommissions: TPartnerCommissionValue[] = [],
): TPartnerCommissionValue[] => currencies.map((currency) => {
  const currentCommission = currentCommissions.find((commission) => commission.currency === currency);

  return {
    currency,
    commissionPercent: currentCommission?.commissionPercent ?? 0,
    calculationBase: currentCommission?.calculationBase ?? 'platform_commission',
  };
});
